<template>
  <div>
    <b-row class="mb-1">
      <b-col v-if="$can('Save', 'MerchantsHostingPage')" md="3">
        <b-button :to="{ name: 'MerchantsHostingPage-add' }" variant="primary">
          <feather-icon icon="PlusIcon" />
          <span class="align-middle ml-50">Add New</span>
        </b-button>
      </b-col>
    </b-row>
    <b-card title="Hosting Page Configuration">
      <b-row>
        <b-col md="3">
          <b-form-group>
            <b-form-input
              v-model="filter"
              placeholder="Search"
              type="text"
              class="d-inline-block mr-1"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            striped
            :items="items"
            :fields="fields"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            caption-top
            :responsive="true"
          >
            <template v-slot:cell(status)="data">
              <b-badge v-if="data.item.status === 2" pill variant="success">
                Active
              </b-badge>
              <b-badge v-else-if="data.item.status === 1" pill variant="danger">
                InActive
              </b-badge>
            </template>

            <template
              v-slot:cell(actions)="data"
              v-if="
                $can('Update', 'Merchants') ||
                  $can('AssignUnAssign', 'Companies')
              "
            >
              <b-row>
                <b-form-group>
                  <b-dropdown
                    variant="link"
                    no-caret
                    :right="$store.state.appConfig.isRTL"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </template>
                    <b-dropdown-item
                      v-if="$can('Update', 'MerchantsHostingPage')"
                      href="#"
                      variant="warning"
                      :to="{
                        name: 'MerchantsHostingPage-edit',
                        params: {
                          id: data.item.merchantId,
                        },
                      }"
                    >
                      <feather-icon class="primary" icon="EyeIcon" />
                      <span class="align-middle ml-50">Edit</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="$can('View', 'MerchantsHostingPage')"
                      href="#"
                      variant="success"
                      :to="{
                        name: 'MerchantsHostingPage-detail',
                        params: {
                          id: data.item.merchantId,
                        },
                      }"
                    >
                      <feather-icon class="primary" icon="EyeIcon" />
                      <span class="align-middle ml-50">Details</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-form-group>
              </b-row>
            </template>
          </b-table>
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to &nbsp; </span>
              <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="[5, 10, 15, 20, { value: 100, text: 'Show all' }]"
                size="sm"
              ></b-form-select>
              <span class="text-nowrap">
                &nbsp; of {{ items.length }} entries
              </span>
            </div>
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-modal
            id="modal-assignpaymentoptions"
            title="Assign Payment Option"
            ok-title="submit"
            size="lg"
            cancel-variant="outline-secondary"
            @ok="submitAssignFops"
          >
            <b-form>
              <b-form-group label="Select Payment Options">
                <b-form-checkbox-group
                  v-model="assignSelected"
                  :options="assignOptions"
                  switches
                  stacked
                />
              </b-form-group>
              <h3>selected Merchant:{{ selectedMerchant }}</h3>
            </b-form>
          </b-modal>
        </b-col>
      </b-row>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BButton,
  BRow,
  BCol,
  BFormInput,
  BFormSelect,
  BLink,
  BTable,
  BPagination,
  BForm,
  BFormGroup,
  BFormCheckboxGroup,
  BCard,
  BOverlay,
  BDropdownItem,
  BDropdown,
  BBadge,
} from "bootstrap-vue";
import { required } from "@validations";
import axios from "@axios";

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BFormInput,
    BFormSelect,
    BTable,
    BPagination,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BCard,
    BOverlay,
    BDropdownItem,
    BDropdown,
    BLink,
    BBadge,
  },
  data() {
    return {
      selectedStatus: 2,
      statusOptions: [
        { value: 2, text: "Active" },
        { value: 1, text: "InActive" },
        { value: 0, text: "All" },
      ],
      required,
      name: "",
      emailValue: "",
      isLoading: false,
      props: ["items"],
      fields: [
        "merchant",
        "titleName",
        "backgroundColor",
        "headerColor",
        "textColor",
        "buttonColor",
        "actions",
      ],
      items: [],
      filter: "",
      perPage: 10,
      currentPage: 1,
      options: [],
      assignOptions: [],
      selected: [],
      assignSelected: [],
      selectedMerchant: "",
      selectedMerchantId: null,
      apiitems: [],
      returnedAssignedFops: [],
      returnedFops: [],
      selectedAssignedIds: [],
      selectedIds: [],
      companyIdOptions: [],
      selectedMerchantName: "",
      merchants: [],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Merchants-View");
      axios
        .get("/Merchant/api/V1.0/Merchants/GetMerchants")
        .then((res1) => {
          axios
            .get("/Merchant/api/V1.0/Merchants/GetAllMerchantDetails")
            .then((res2) => {
              this.items = res2;
              this.items.map((item) => {
                res1.merchants.filter((merchant) =>
                  item.merchantId === merchant.id
                    ? (item.merchant = merchant.name)
                    : null
                );
              });
              this.isLoading = false;
            })
            .catch((res) => {
              this.isLoading = false;
            });
        })
        .catch((err) => {
          console.log(err);
        });

      // this.options = apioptions.paymentOptions
    },
    EnableMerchant(id, name) {
      this.$bvModal
        .msgBoxConfirm(`Are you sure to Enable  ${name}`, {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          headerBgVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isLoading = true;
            this.$store.dispatch(
              "config/getActionPrivilege",
              "Merchants-AssignUnAssign"
            );

            axios
              .put(
                "/Merchant​/api​/V1.0​/Merchants​/ActivateDeactivatePaymentOption",
                {
                  statusAction: 1,
                  id,
                }
              )
              .then((res) => {
                this.isLoading = false;
                // eslint-disable-next-line no-alert
                this.$bvModal.msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                });
                this.fetchData();
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        });
    },
    DisableMerchant(id, name) {
      this.$bvModal
        .msgBoxConfirm(`Are you sure to Disable  ${name}`, {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          headerBgVariant: "warning",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isLoading = true;
            this.$store.dispatch(
              "config/getActionPrivilege",
              "Merchants-AssignUnAssign"
            );

            axios
              .put("/Merchant/api/V1.0/Merchants/ActivateDeactivateMerchant", {
                statusAction: 2,
                id,
              })
              .then((res) => {
                this.isLoading = false;
                this.$bvModal.msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                });
                this.fetchData();
              })
              .catch((res) => {
                this.isLoading = false;
              });
          }
        });
    },
    enableMerchantfop(id, name) {
      this.selectedMerchantId = id;
      this.selectedMerchant = name;
      this.selected = [];
      this.selectedIds = [];
      this.returnedFops = [];
      this.options = [];
      this.isLoading = true;
      this.$store.dispatch(
        "config/getActionPrivilege",
        "Merchants-AssignUnAssign"
      );
      axios
        .get(
          `/PaymentOptions/api/V1.0/PaymentOptions/GetAllMerchantPaymentOptions?MerchantId=${id}`
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.options.push({
              value: item.id,
              text: item.name,
            });
            this.returnedFops.push({
              id: item.id,
              status: item.status,
            });
            if (item.status === 2) {
              this.selected.push(item.id);
            }
          });
          this.$bvModal.show("modal-paymentoptions");
          this.isLoading = false;
        })
        .catch((res) => {
          this.$bvModal.msgBoxOk(`${res.data.message}`, {
            title: "Success",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
          this.isLoading = false;
        });
    },
    assignMerchant(id, name) {
      this.selectedMerchantId = id;
      this.selectedMerchant = name;
      this.assignSelected = [];
      this.assignOptions = [];
      this.returnedAssignedFops = [];
      this.selectedAssignedIds = [];
      this.isLoading = true;
      this.$store.dispatch(
        "config/getActionPrivilege",
        "Merchants-AssignUnAssign"
      );
      axios
        .get(
          `/PaymentOptions/api/V1.0/PaymentOptions/ViewAssignedUnAssignedPaymentOptionsByMerchant?merchantId=${this.selectedMerchantId}`
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.assignOptions.push({
              value: item.id,
              text: item.name,
            });
            this.returnedAssignedFops.push({
              paymentOptionId: item.id,
              merchantFopId: item.merchantPaymentOptionId,
              assigned: item.isAssigned,
            });
            if (item.isAssigned) {
              this.assignSelected.push(item.id);
            }
          });
          this.$bvModal.show("modal-assignpaymentoptions");
          this.isLoading = false;
        })
        .catch((res) => {
          this.$bvModal.msgBoxOk(`${res.data.message}`, {
            title: "Success",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
          this.isLoading = false;
        });
    },
    submitAssignFops() {
      this.returnedAssignedFops.forEach((item) => {
        if (this.assignSelected.includes(item.paymentOptionId)) {
          this.selectedAssignedIds.push({
            paymentOptionId: item.paymentOptionId,
            merchantPaymentOptionId: item.merchantFopId,
          });
        }
      });
      this.isLoading = true;
      axios
        .post(
          "/PaymentOptions/api/V1.0/PaymentOptions/AssignUnAssignPaymentOptionsToMerchantByMerchant",
          {
            paymentOptions: this.selectedAssignedIds,
          }
        )
        .then((res) => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk(`${res.message}`, {
            title: "Success",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        })
        .catch(() => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk("No Returned data", {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        });
    },
  },
};
</script>
